import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { Provider, ToastContainer } from './utils/thirdpartyComponents';
//import '@fontsource-variable/plus-jakarta-sans';
import './styles/main.scss';
import { renewToken } from './config/axiosConfig';
import { clearStorageLogout, getFromLocalStorage, updateTokensInStorage } from './utils/helper';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);
// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
try {//added for white screen fix
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <App />
    <ToastContainer />
  </React.StrictMode>
  </Provider>
);
} catch (err) {
  console.error('React render failed, reloading app...', err);
  window.location.reload();
}

// Prevent multiple reloads
let isReloading = false;

// White screen detection
document.addEventListener('DOMContentLoaded', () => {
  const checkRender = setTimeout(() => {
    const appContainer = document.querySelector('#root') as HTMLElement | null;
    if (!appContainer || appContainer.innerHTML.trim() === '' && !isReloading) {
      console.warn('White screen detected, reloading...');
      isReloading = true;
      window.location.reload();
    }
  }, 3000);
  window.addEventListener('load', () => clearTimeout(checkRender));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// -------------------------------
//  Service Worker Update 
// -------------------------------
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      try {
      // Send SKIP_WAITING message to the waiting SW
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        } catch (error) {
        console.error('Failed to send SKIP_WAITING message:', error);
        // Optionally notify user to manually refresh
        alert('A new version is available. Please refresh the page.');
      }
      // Force reload when new SW takes control
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    }
  },
});

//  Resume-Time Token Refresh on App Visibility
window.addEventListener('visibilitychange', async () => {
  if (document.visibilityState === 'visible') {
    console.log('[PWA RESUME] App resumed — checking session');

    const storageData = getFromLocalStorage('CARWASH_DATA');
    if (storageData?.accessToken) {
      try {
        const res = await renewToken();
        if (res?.status === 498 || res?.status === 499 || res?.error !== 0) {
          console.log('Token invalid, forcing logout');
          clearStorageLogout();
        } else {
          const newAccessToken = res?.data?.accessToken || '';
          const newRefreshToken = res?.data?.refreshToken || '';
          updateTokensInStorage(newAccessToken, newRefreshToken);
          console.log('[Token Refresh] Token updated on resume.');
        }
      } catch (e) {
        console.error('[Token Refresh] Failed on resume:', e);
        clearStorageLogout();
      }
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

